/*
 * Ariser: colour-family filtering.
 *
 * Used by two UIs that share one grouping (snippets/ariser-colour-groups.liquid):
 *   - the mobile colour strip under the toolbar  (.ariser-cs squares, .ariser-chip)
 *   - the grouped colour swatches in the filter drawer (.ariser-fam buttons)
 *
 * A tap on a family ticks (or unticks) every shade checkbox belonging to that family inside
 * the theme's storefront filter form, then fires the form's `input` event. Minimog's
 * collection-filters-form element listens for that, fetches the filtered section and swaps it
 * in, which re-renders both UIs with the server-side active state. Several families can be
 * selected together.
 *
 * Event delegation on document keeps this working after every re-render.
 */
(function () {
  'use strict';

  function findForm() {
    return document.getElementById('CollectionFiltersForm');
  }

  function setValues(form, param, values, checked) {
    var touched = 0;
    var inputs = form.querySelectorAll('input[type="checkbox"][name="' + param + '"]');
    values.forEach(function (v) {
      if (!v) return;
      inputs.forEach(function (input) {
        if (input.value === v && !input.disabled && input.checked !== checked) {
          input.checked = checked;
          touched++;
        }
      });
    });
    return touched;
  }

  function apply(form, container) {
    container.classList.add('is-busy');
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function fallbackNavigate(param, btn) {
    var url = new URL(window.location.href);
    url.searchParams.delete(param || '');
    if (btn.getAttribute('data-family') !== 'all') {
      (btn.getAttribute('data-values') || '').split('|').filter(Boolean).forEach(function (v) { url.searchParams.append(param, v); });
    }
    window.location.href = url.toString();
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.ariser-cs, .ariser-chip, .ariser-fam');
    if (!btn) return;
    var container = btn.closest('[data-param]');
    if (!container) return;
    evt.preventDefault();

    var form = findForm();
    var param = container.getAttribute('data-param');
    if (!form || !param) { fallbackNavigate(param, btn); return; }

    var family = btn.getAttribute('data-family');
    var isStrip = container.hasAttribute('data-ariser-cstrip');

    if (family === 'all') {
      var all = form.querySelectorAll('input[type="checkbox"][name="' + param + '"]:checked');
      if (!all.length) return;
      all.forEach(function (i) { i.checked = false; });
      container.querySelectorAll('.ariser-cs').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-family') === 'all'); });
      apply(form, container);
      return;
    }

    var values = (btn.getAttribute('data-values') || '').split('|').filter(Boolean);
    var currentlyOn = btn.classList.contains('ariser-chip') ? true
      : btn.classList.contains('ariser-fam') ? btn.closest('li').classList.contains('active')
      : btn.classList.contains('is-on');
    var turnOn = !currentlyOn;
    var touched = setValues(form, param, values, turnOn);
    if (!touched) return;

    // immediate visual feedback; the re-rendered markup will carry the real state
    if (isStrip) {
      var square = container.querySelector('.ariser-cs[data-family="' + family + '"]');
      if (square) { square.classList.toggle('is-on', turnOn); square.setAttribute('aria-pressed', String(turnOn)); }
      var anyOn = container.querySelectorAll('.ariser-cs.is-on:not(.ariser-cs--all)').length > 0;
      var allBtn = container.querySelector('.ariser-cs--all');
      if (allBtn) allBtn.classList.toggle('is-on', !anyOn);
    } else {
      var li = btn.closest('li');
      if (li) li.classList.toggle('active', turnOn);
      btn.setAttribute('aria-pressed', String(turnOn));
    }
    apply(form, container);
  });
})();
